import { ClaimMappingFormValue } from "./index";

type ValidateClaimNameParams = {
  value: string | undefined;
  index: number;
  claimFields: ClaimMappingFormValue[];
};

type ValidateClaimValueParams = {
  value: string | undefined;
  index: number;
  claimFields: ClaimMappingFormValue[];
};

export const validateProviderClaimName = ({
  value,
  index,
  claimFields,
}: ValidateClaimNameParams) => {
  const hasSpaceliftClaimName = Boolean(claimFields[index]?.value?.trim());

  // Rule 1: If Spacelift claim name is filled, Provider claim name is required
  if (hasSpaceliftClaimName && !value?.trim()) {
    return "Provider claim name is required";
  }

  // Rule 2: Provider claim name values must be unique
  if (value?.trim()) {
    const claimsWithSameName = claimFields.filter(
      (claimField) => claimField.name.toLowerCase().trim() === value.toLowerCase().trim()
    );
    const hasDuplicates = claimsWithSameName.length > 1;

    if (hasDuplicates) {
      return "Provider claim name must be unique";
    }
  }

  return true;
};

export const validateSpaceliftClaimName = ({
  value,
  index,
  claimFields,
}: ValidateClaimValueParams) => {
  const hasProviderClaimName = Boolean(claimFields[index]?.name?.trim());

  // Rule 1: If Provider claim name is filled, Spacelift claim name is required
  if (hasProviderClaimName && !value?.trim()) {
    return "Spacelift claim name is required";
  }

  return true;
};
